import React, { useCallback, useEffect, useState } from 'react'
import 'react-toastify/dist/ReactToastify.css'
import { SelectWithLabelInput } from '../../Atoms/Inputs/SelectWithLabel'
import { ButtonWithIcon } from '../../Atoms/Buttons/ButtonWithIcon'
import { TextInput } from '../../Atoms/Inputs/Text'

const statuses = [
    {
        name: 'All',
        value: 'all',
    },
    {
        name: 'Success',
        value: 'success',
    },
    {
        name: 'Failed',
        value: 'failed',
    },
]
export const LogsHeader = React.memo(({ onSearch, search: _search }) => {
    const [search, setSearch] = useState(_search)

    const setSearchProp = useCallback(
        (key, value) => {
            setSearch((search) => ({
                ...(search ? search : {}),
                [key]: value,
            }))
        },
        [search, setSearch],
    )

    useEffect(() => {
        setSearch(_search)
    }, [_search])

    useEffect(() => {
        const handler = (e) => {
            if (e.key === 'Enter') {
                handleSubmit(e)
            }
        }

        window.addEventListener('keydown', handler)
        return () => window.removeEventListener('keydown', handler)
    }, [search])

    const handleSubmit = () => {
        console.log('handleSubmit', { ...search, page: 1 })
        onSearch({ ...search, page: 1 })
    }
    return (
        <div>
            <div className="tableHeader">
                <div className="tableHeaderText">Logs</div>
                <div className="tableHeaderButton logsHeaderButton">
                    <TextInput
                        marginTop={'0px'}
                        placeholder="Search flow name"
                        value={search.flowName}
                        onChange={({ target }) => {
                            setSearchProp('flowName', target.value)
                        }}
                    />
                    <TextInput
                        marginTop={'0px'}
                        placeholder="Search by request ip"
                        value={search.ip}
                        onChange={({ target }) => {
                            setSearchProp('ip', target.value)
                        }}
                    />
                    <SelectWithLabelInput
                        options={statuses}
                        defaultValue={search.status}
                        onChange={({ target }) => {
                            setSearchProp('status', target.value)
                        }}
                    />
                    {/* ✅ Start Date */}
                    <input
                        type="datetime-local"
                        className="dateInput"
                        value={search.startDate || ''}
                        onChange={({ target }) =>
                            setSearchProp('startDate', target.value)
                        }
                    />

                    {/* ✅ End Date */}
                    <input
                        type="datetime-local"
                        className="dateInput"
                        value={search.endDate || ''}
                        onChange={({ target }) =>
                            setSearchProp('endDate', target.value)
                        }
                    />
                    <ButtonWithIcon
                        onClick={() => onSearch({ ...search, page: 1 })}
                        green={true}
                        value={'Search'}
                    />
                </div>
            </div>
        </div>
    )
})
